const StickyHeader = (element) => {
  const article = document.querySelector('.mainArticle');

  const addScrollListeners = () => {
    window.addEventListener('scroll', () => {
      const scrollTop = window.scrollY;
      
      if (article) {
        const articleHeight = article.offsetHeight;
        
        if (scrollTop > 300 && scrollTop < articleHeight) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      }
    });
  }

  const main = () => {
    addScrollListeners();
  }

  main();
};

export default StickyHeader;
